import { Component, Input } from '@angular/core';
import * as utils from 'src/app/shared/helpers/utils';


@Component({
  selector: 'hbo-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent {

  videoURL!: string;

  @Input() id?: string | number;

  constructor() {
    this.videoURL = JSON.parse(localStorage.getItem('video')!)?.video;
  }

  ngOnInit() {
    const videoSkip = (document.querySelector('#videoSkip') as HTMLButtonElement);
    const video = (document.querySelector('#video') as HTMLVideoElement);
    video.addEventListener('ended', function (e) {
      videoSkip.click();
    })
  }

}
